import classNames from 'classnames'
import Icon from '@components/Icon'
import './styles.scss'

const FeatureBlock = ({ label, icon, details, children, size = 'xl', className }) => (
    <div className={classNames('feature-block', { [`feature-block--${size}`]: !!size, [className]: !!className })}>
        <Icon type={icon} size={size} />
        <div className="feature-block__content">
            {label}
            {details && <div className="feature-block__details">{details}</div>}
            {children && <div className="feature-block__children">{children}</div>}
        </div>
    </div>
)

FeatureBlock.propTypes = {
    size: PropTypes.oneOf(['xs', 'sm', 'xl']),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    icon: PropTypes.string.isRequired,
    details: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}

export default FeatureBlock
